export default __webpack_public_path__ + "static/media/RebootNova.d0bdb091.pdf";